import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import {
  INDIVIDUAL_WORKERS_FOR_SELECT_PATH,
  WORKERS_FOR_SELECT_PATH,
} from './key';
import type { Category, WorkersResponse } from './type';

export const getWorkersForSelect = async (
  searchText: string,
  page: number,
  category?: Category,
  options?: { isIndividual?: boolean; excludeNotHaveWorkerEmail?: boolean },
): Promise<WorkersResponse> => {
  if (options?.isIndividual) {
    const res = await apiClient.GET(INDIVIDUAL_WORKERS_FOR_SELECT_PATH, {
      params: {
        query: {
          freeText: searchText,
          page,
          category,
          excludeNotHaveWorkerEmail: options.excludeNotHaveWorkerEmail,
        },
      },
    });
    const data = getDataOrThrowApiError(res);
    return {
      ...data,
      items: data.items.map((item) => ({
        personId: item.personId,
        name: item.name,
        namePronunciation: '',
      })),
    };
  }

  const res = await apiClient.GET(WORKERS_FOR_SELECT_PATH, {
    params: {
      query: {
        freeText: searchText,
        page,
        category,
        excludeNotHaveWorkerEmail: options?.excludeNotHaveWorkerEmail,
      },
    },
  });
  return getDataOrThrowApiError(res);
};
